<script setup lang="ts">
import { union } from "lodash-es"
import { PostsProps } from "./Posts.props"
import { useI18n } from "vue-i18n"

const props = defineProps<PostsProps>()

const { t } = useI18n()

const route = useRoute()
const searchQuery = ref((route.query.query as string) || "")

const postsInfo = reactive(props?.postsList ?? null)
const currentTotal = computed(() => postsInfo?.postsList.length ?? 0)

const url = (skip: number) =>
  route.params.category
    ? `/api/magazine/getPostsCategoryPagination/${skip}/12/${route.params.category}`
    : `/api/magazine/getPostsPagination/${skip}/12`

// const showMoreData = async () => {
//   const { data: infoAllPosts } = await useFetch(url(currentTotal.value), {
//     method: "GET"
//   })
//   // @ts-ignore
//   const unionArrays = union(postsInfo.postsList, infoAllPosts?.value?.posts)
//   postsInfo.postsList = unionArrays
// }
</script>

<template>
  <SeoBase v-if="seo" v-bind="seo" />
  <UtilsBreadcrumbs v-if="breadcrumbsLinks" v-bind="breadcrumbsLinks" />
  <div class="md:grid-standard">
    <div
      class="
        col-span-full
        flex
        aspect-[4/1]
        flex-col
        justify-center
        bg-default-green-10
        px-4
      "
    >
      <!-- Search form -->
      <div class="col-span-full">
        <ClientOnly>
          <SearchMagazineSearchBar
            v-model="searchQuery"
            :placeholder="t('magazine.search.placeholder')"
          />
          <template #fallback>
            <SkeletonMagazineSearchBar />
          </template>
        </ClientOnly>
      </div>
    </div>
  </div>
  <div class="posts-wrapper padded">
    <template v-if="postsInfo">
      <div v-if="postsInfo.postsList.length === 0">
        <AlgoliaNoResults />
      </div>
      <div v-else>
        <GridListPosts
          v-bind="postsInfo"
          :hasDropdownCategory="hasDropdownCategory"
        />
      </div>
    </template>
    <BannerNewsletter />
  </div>
</template>
